/** Shared pagination contract for KG drawer/tab APIs. */
export interface KgPageInfo {
  cursor: string | null;
  hasMore: boolean;
  total: number;
}

export interface KgPaginatedRows<T> {
  rows: T[];
  pageInfo: KgPageInfo;
}

export const emptyKgPageInfo = (total = 0): KgPageInfo => ({
  cursor: null,
  hasMore: false,
  total,
});
